import globalPostFields from '@/lib/wp/_partials/globalPostFields';
import defaultPageData from '@/lib/wp/_partials/defaultPageData';
import { gql } from '@apollo/client';

const queryPartnerById = gql`
  query GET_PARTNER_BY_ID($id: ID!, $idType: PartnerIdType = SLUG) {
    ${defaultPageData}
    partner(id: $id, idType: $idType) {
      partnerInformation {
        channelName
        partnerLogo {
          ... on MediaItem {
            sourceUrl
          }
        }
        partnerLink {
          url
          title
        }
        partnerAccentColor
        featuredImageBackgroundColor
        partnerFollowCode
        partnerFeatured {
          ... on Post {
            databaseId
          }
        }
        partnerAbout
      }
      blocksJSON
      ${globalPostFields}
    }
  }
`;

export default queryPartnerById;
